var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#161015"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1659 17.7822L19.4855 19.3195L27.2235 32.6324L29.9039 31.0951L22.1659 17.7822Z",
    fill: "#E4ADBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6526 25.0908L12.0992 27.7512L25.5516 35.4315L27.1049 32.7711L13.6526 25.0908Z",
    fill: "#73D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 35.5872H10V38.6971H25.4722V35.5872Z",
    fill: "#CB3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3843 35.5872H37.9121V38.6971H53.3843V35.5872Z",
    fill: "#116ECD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7318 25.0908L36.2794 32.7711L37.8328 35.4315L51.2851 27.7513L49.7318 25.0908Z",
    fill: "#FFEAEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2185 17.7822L33.4805 31.0951L36.1609 32.6324L43.8989 19.3195L41.2185 17.7822Z",
    fill: "#F4C635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2471 15.6831H30.1371V30.9998H33.2471V15.6831Z",
    fill: "#0A8E4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app-icon.1ca616c44e4c2d37d33bcb12680c2d50.svg";
export { ForwardRef as ReactComponent };